import React from 'react';
import { signatureDishes } from '../data/mockData';

const Menu = () => {
  return (
    <section id="menu" className="menu-section">
      <div className="menu-container">
        <h2 className="section-title">Signature Dishes</h2>
        
        <div className="dishes-grid">
          {signatureDishes.map((dish) => (
            <div key={dish.id} className="dish-card">
              <div className="dish-image-wrapper">
                <img 
                  src={dish.image} 
                  alt={dish.name}
                  className="dish-image"
                />
              </div>
              <div className="dish-content">
                <div className="dish-header">
                  <h3 className="dish-name">{dish.name}</h3>
                  <span className="dish-price">{dish.price}</span>
                </div>
                <p className="dish-description">{dish.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Menu;
